export const DOMAIN = 'consentConfigDetails.configuration.scripts';
